import { BLOCK_STYLE } from './constants';

interface CalendarLegendProps {
  isMobile: boolean;
  showBlocks: boolean;
  calendarFilters: { assigned_to: string };
  showReminders?: boolean;
}

/**
 * Shared Calendar Legend.
 *
 * Booking status colours are NOT shown here — each booking card displays
 * its status as a labelled pill ("Confirmed", "Pending"...), so the colour
 * key was redundant and added clutter.
 *
 * The legend only carries items that have a colour-only meaning:
 *   - Blocked: orange operator-availability blocks
 *   - Available: green time-slot tint shown when a single operator is filtered
 *
 * If neither is on screen the legend renders nothing.
 */
export default function CalendarLegend({ isMobile, showBlocks, calendarFilters, showReminders = false }: CalendarLegendProps) {
  const showAvailable = calendarFilters.assigned_to !== 'all';
  if (!showBlocks && !showAvailable && !showReminders) return null;

  return (
    <div className={`cal-legend ${isMobile ? 'cal-legend--mobile' : ''}`}>
      {showBlocks && (
        <div className={`cal-legend-item ${isMobile ? 'cal-legend-item--mobile' : ''}`}>
          <span className="cal-legend-dot" style={{ background: BLOCK_STYLE.border }} />
          Blocked
        </div>
      )}
      {showReminders && (
        <div className={`cal-legend-item ${isMobile ? 'cal-legend-item--mobile' : ''}`}>
          <span className="cal-legend-dot cal-legend-dot--reminder" />
          Reminder
        </div>
      )}
      {showAvailable && (
        <div className={`cal-legend-item ${isMobile ? 'cal-legend-item--mobile' : ''}`}>
          <span className="cal-legend-dot cal-legend-dot--bordered" style={{ background: 'var(--color-success-bg)' }} />
          Available
        </div>
      )}
    </div>
  );
}
